import { compose } from 'shared/utils/function.utils';
import { loadCreditLineReducer } from './load-credit-limits';

export const extraReducers = compose(loadCreditLineReducer);

export { loadCreditLimitsAction } from './load-credit-limits';
